import { render, staticRenderFns } from "./OmnichannelControls.vue?vue&type=template&id=f2fe5750"
import script from "./OmnichannelControls.vue?vue&type=script&lang=js"
export * from "./OmnichannelControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports